<template>
    <div>
    <a-switch-field
      varName="token_endpoint_options.grant_type.refresh_token.enabled"
      varLabel="Refresh Token Grant"
      :varRequired="true"
      :varInitial="data.token_endpoint_options.grant_type.refresh_token.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Exchange a refresh token for an access token when the access token has expired."
    />
    <a-switch-field
      varName="token_endpoint_options.grant_type.password.enabled"
      varLabel="Username Password Grant"
      :varRequired="true"
      :varInitial="data.token_endpoint_options.grant_type.password.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Exchange a user's credentials for an access token. This grant type is not recommended."
    />
    <a-switch-field
      varName="token_endpoint_options.grant_type.client_credentials.enabled"
      varLabel="Client Credential Grant"
      :varRequired="true"
      :varInitial="data.token_endpoint_options.grant_type.client_credentials.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Used by Clients (IoT Devices, M2M) to obtain an access token outside of the context of a user."
    />
    <a-switch-field
      varName="token_endpoint_options.grant_type.authorization_code.enabled"
      varLabel="Authorization Code Grant"
      :varRequired="true"
      :varInitial="data.token_endpoint_options.grant_type.authorization_code.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Used by clients to exchange an authorization code for ID Token, Access Token, and/or Refresh Token."
    />
    <a-switch-field
      varName="token_endpoint_options.grant_type.device_code.enabled"
      varLabel="Device code"
      :varRequired="true"
      :varInitial="data.token_endpoint_options.grant_type.device_code.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Used by browserless or input-constrained devices to exchange a previously obtained device code for an access token."
    />
    </div>
</template>

<script>
export default {
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
}
</script>